<script setup>
  import { ref, onMounted } from 'vue'
  const useBreadcrumbs = useBreadcrumbsStore()
  const localePath = useLocalePath()
  const breadcrumbsRef = ref(null)

  onMounted(() => {
    // Mettre à jour la hauteur du header en incluant le fil d'Ariane
    if (breadcrumbsRef.value) {
      const currentHeaderHeight =
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
      const totalHeight = currentHeaderHeight + breadcrumbsRef.value.offsetHeight
      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`)
    }
  })
</script>

<template>
  <nav
    v-if="!useBreadcrumbs.hidden"
    ref="breadcrumbsRef"
    class="bg-slate-50 border-b border-slate-200 relative z-[1000]"
    aria-label="Breadcrumb"
  >
    <ol role="list" class="container flex h-8 overflow-hidden pointer-events-none">
      <li class="flex shrink-0">
        <div class="flex items-center">
          <NuxtLink
            :to="localePath({ name: 'index' })"
            class="text-slate-400 hover:text-sky-800 flex items-center pointer-events-auto"
          >
            <font-awesome class="text-sm fa-fw" :icon="['fas', 'house']" />
            <span class="sr-only">Home</span>
          </NuxtLink>
        </div>
      </li>
      <client-only>
        <template v-if="useBreadcrumbs.crumbs && useBreadcrumbs.crumbs.length > 0">
          <li v-for="crumb in useBreadcrumbs.crumbs" :key="crumb.name" class="flex">
            <div class="flex items-center">
              <svg
                class="h-full w-4 shrink-0 text-slate-200 ml-2"
                viewBox="0 0 24 44"
                preserveAspectRatio="none"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
              </svg>
              <NuxtLink
                :to="localePath({ name: crumb.path, params: crumb.params || {} })"
                class="ml-2 text-sm text-slate-500 hover:text-sky-800 truncate md:text-clip max-w-[60vw] lg:max-w-7xl pointer-events-auto"
                :title="crumb.name"
              >
                {{ crumb.name }}
              </NuxtLink>
            </div>
          </li>
        </template>
      </client-only>
    </ol>
  </nav>
</template>
